import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Capacitor } from '@capacitor/core';
import { environment } from 'environments/environment';
import { CodaltComponent } from '../../codalt.component';
import { LocalStorage } from '../../local-storage.class';
import { Settings } from '../../settings.class';
import { ImageViewerData } from './image-viewer-data';

@Component({
    selector: 'app-image-viewer-dialog',
    templateUrl: './image-viewer-dialog.component.html',
    styleUrls: ['./image-viewer-dialog.component.scss'],
    standalone: false,
})
export class ImageViewerDialogComponent extends CodaltComponent {
    readonly environment = environment;
    secure = '';
    currentIndex = 0;
    allImages: any[] = [];

    Settings = Settings;
    LocalStorage = LocalStorage;

    showNavigation = !Capacitor.isNativePlatform();

    constructor(
        public dialogRef: MatDialogRef<ImageViewerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public images: ImageViewerData
    ) {
        super();
        if (images.secure) {
            this.secure = `secure=${images.secure}&`;
        }

        // Combine all images into a single array
        this.allImages = [...(images.documentImages || []), ...(images.images || [])];

        this.currentIndex = images.viewIndex || 0;
    }

    nextSlide() {
        if (this.currentIndex < this.allImages.length - 1) {
            this.currentIndex++;
        }
    }

    prevSlide() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
        }
    }

    @HostListener('click', ['$event'])
    public click(event) {
        if (event.target.localName !== 'img' && event.target.className.indexOf('nav-button') === -1) {
            this.dialogRef.close();
        }
    }

    @HostListener('keydown', ['$event'])
    public onKeyDown(event: KeyboardEvent) {
        switch (event.key) {
            case 'ArrowLeft':
                this.prevSlide();
                break;
            case 'ArrowRight':
                this.nextSlide();
                break;
            case 'Escape':
                this.dialogRef.close();
                break;
        }
    }
}
